import { add } from "date-fns";

export var config = {
  auth: {
    login: 'auth/login',
    signup: 'auth/register',
    verify: 'auth/login/verifyOtp',
    logout: 'auth/logout',
    getEncryptionMode: 'site-settings',
    forgetPassword: {
      forgetEmail: 'forget',
      verifyLink: 'cheklinkstatus',
      changePassword: 'auth/forgotPasswordEmail',
      resetPassword: 'auth/sendOtp',
      verifyOtp: 'auth/verifyOtp',
      forgetUser:'auth/username-exist',
      resetUserDetails:'auth/update-username-request'
    },
    // getuserprofile: 'auth/view-profile',
    getuserprofile: 'auth/user/user-prefix-details',

    getpermission: 'api/allpermissionlist',
    havepermission: 'api/have_permission',
    Addpermission: 'api/user_revokepermission',
    getNotification: 'auth/notifications-count',
    role_permission: 'api/role_permission',
    add_role: 'api/role_revokepermission',
    getrole: 'api/getrolelist',
    getpermissionrole: 'api/allpermissionlistbyrole',
    kycStatus: 'auth/kyc-status',
    businessName: 'auth/get-bussiness-name',
    changePassword: 'auth/changePassword',
    updateProfile: 'auth/user/update-profile',
    verifyOtp: 'auth/user/verify-otp',
    updateprofileRequest:'v2/update-user-details',
    verifyprofileOtp:'v2/verify-update-otp'
  },
  Api_Key: {
    getList: 'credentials/keys',
    deactiveKey: 'credentials/deactivate-key',
    pkyUpdate: 'credentials/publickeyCreateUpdate',
    certificateKey: 'credentials/certificate-create-update',
    createApiKey: 'credentials/generate-key',
    sendOTP: 'auth/send-user-otp',
    sendCredEmail: 'credentials/send_cred_email',
    config: 'credentials/update-config',
    getConfig: 'credentials/get-config',
    verifyOTP: 'auth/verify-user-otp',
    addIp: 'credentials/add-ip',
    getIp: 'credentials/get-ip'

  },
  // uploadFile: {
  //   url: "upload-file",
  // },

  payout: {
    create_beneficiary: 'v2/payout/create-beneficiary',
    get_beneficiary: 'v2/payout/beneficiary-list',
    delete_beneficiary: 'v2/payout/delete-beneficiary',
    // make_payment: 'payout/payment',
    make_payment: 'v2/payout/payment',
    payoutOtp: 'v2/payout/send-payout-otp',
    payment_stmt: 'payout/payout-statement',
    export_payment_stmt: 'payout/export-payout-statement',
    payoutSingle: 'payout/payout-count',
    verifyBeni: 'v2/payout/verify-beneficiary',
    // payoutStatus: 'payout/get-payout-status'
    payoutStatus: 'v2/payout/bank-payout-status',
    getCallback: 'v2/payout/get-callback',
    beniCount: 'v2/payout/beneficiary-count',

    updatebane: 'payout/update-bene',
    getEditBeniId: 'payout/get-beneficiary',
    updatebenedata: 'payout/update-beneficiary',
    addUrnRrn: 'payout/add-urn-rrn',

    bulkBeneficiary: 'v2/payout/bulk-beneficiary',
    bulkPayout: 'v2/payout/bulk-payment',

    singleAccountDetails: 'v2/payout/get-single-account',
    bulkReport: 'payout/bulk-payout-report',
    bulkBatchReport: 'payout/bulk-payout-batch-report'

  },
  bankAccList: {
    url: 'service/get-account-lists',
    bank_list: 'auth/get-all-banks',
  },

  dashboard: {
    dashboard_api: '/api/dashboard',
    pie_chart: '/api/piechart',
    bar_graph: '/api/graphchart',
    service: 'service/get-service'
  },
  ticketing: {
    raise: {
      //general issues start
      support_type: 'ticket/get-support-types',
      request_type: 'ticket/get-request-types',
      //general issues end

      //txn issues start
      get_services: 'ticket/get-services',
      txn_issues: "ticket/get-txn-issues",
      //txn issues end

      universal_form: 'ticket/view-universal-form',
      raise_ticket: 'ticket/raise-ticket',
    },
    track: {
      my_tickets: 'ticket/my-tickets',
      get_ticket_details: 'ticket/get-ticket-details',
      add_comment: 'ticket/add-comment-to-ticket',
      close_ticket: 'ticket/close-ticket',
      reopen_ticket: 'ticket/reopen-ticket',


    },

  },
  verify_dashboard: {
    dashboard_api: 'v2/payout/all-accounts',
    // single_account: 'dashboard/get-dashboard-accounts',
    single_account: 'v2/payout/balance-fetch',


    dashboardData: 'dashboard/dashboard-count',
    bussniessTrend: 'dashboard/bussniess-trend',
    dashboardPayoutCount: 'dashboard/payout-count',
    dashboardVaTxnCount: 'dashboard/va-transactions-count',
    dashboardUpiCount: 'dashboard/merchant-upi-count',
    dashboardDetail: 'dashboard/dashboard-detail',
    payoutGraph: 'dashboard/payout-graph-data',
    collectionGraph: 'dashboard/collection-graph-data',
    getAllDashboardStats: 'dashboard/get-dashboard-stats',
  },
  createBank: {
    userAccountList: 'bank/user-account-list',
    getAccountDetails: 'bank/user-account',
    // getAccountDetails: 'bank/getAccountDetails',
    getbanks: 'bank/banklist',
    getBankForm: 'bank/getbankForm',
    add_bank_account: 'bank/add-bank-account',
    get_account_type: 'bank/account-types',
  },
  bankCrednitial: {
    getFormdata: 'bank/get-formdata',
    // addBankCrednitial: 'bank/add-bank-crednitial',
    getCrednitial: 'bank/get-crednitial',
    deleteCrednitial: 'bank/delete-crednitial',
    editCrednitial: 'bank/edit-bank-crednitial',
    getAddBankForm: 'credentials-manager/view-form',
    addBankCrednitial: 'credentials-manager/update-form',
    viewCredential: 'credentials-manager/view-details',
  },
  header: {
    getbalance: 'api/getbalance',
  },

  sidemenu: {
    // live: 'permissions/leftPanel',

    live: 'permissions/leftPanelV2',
    topPanel: 'permissions/top-panel',
  },

  apikey: {
    key: '/api/getapikeyslist',
  },

  // fileUpload: {
  //   upload: '/api/upload-file',
  // },

  qr: {
    qrGenerate: 'v2/qr/create-qr',
    getActiveVpaList: 'qr/get-active-vpa',
    getVpaDetails: 'qr/get-vpa-details',
    getQrLogo: 'qr/qr-logos',
    saveQrLogo: 'qr/save-qr-logo',
    QrStatement: 'qr/statement',
    QrSingleStatement: 'qr/single-statement',
    qrTransaction: 'qr/transactions',
    vpaReport: 'qr/vpa-report',
    exportQrTxn: 'qr/export-qr-txn',
    exportVpaReport: 'qr/export-vpa-report',
    getSuffix: 'qr/get-suffix',
    delete_logo: 'qr/delete-logo',
    updateVpa: 'qr/update-vpa',
    qaExport: 'qr/export-qa-accn-txn',
    qrStatus: 'qr/qr-status',
    getCallback: 'qr/get_payin_callback',
    getDynamicForm: 'service/get-dynamic-form',
  },

  va: {
    VaStatement: 'va/list',
    vaGenerate: 'va/create-va',
    VaSignlestatement: 'va/statement',
    getprefix: 'va/get-prefix',
    vaTransaction: 'va/transactions',
    updateVa: 'va/update-va',
    updateStatus: 'va/approve-transaction',
    vaExport: 'va/export-va-accn',
    vaStatementExport: 'va/export-va-accn-txn',
    viewUploadedReq: 'va/viewVaUploads',
    uploadBulkFile: 'bulkUpload',
    vaAccUserList: 'va-acc-user-list',
    whiteListAccountList: 'white-list-account-list',
    whiteListAccountDelete: 'delete-whitelist-account',
    allBanksList: 'all-banks-list',
    addWhitelistAccount: 'add-whitelist-account',
    updateWhitelistAccount: 'update-whitelist-account',
  },

  statement: {
    // accountstatement: 'auth/accountstatement',
    accountList: 'dashboard/get-account',
    accountstatement: 'v2/payout/account-statement',
  },
  reports: {
    reports: 'report/all-requests',
    CreateReport: 'report/request',
  },
  reportsNew: {
    payoutNew: 'payout/payout-statement',
    download: 'payout/export-payout-statement',
    filter: '/bank/banklist',
    getTxnIssues: '/ticket/get-txn-issues'
  },
  walletStatmentReports: {
    walletStatmentDownload: 'auth/wallet-transactions-downloads',
    walletTransaction: 'auth/wallet-transactions'
  },
  ecollect: {
    ecollectReport: 'va/transactions',
    ecollectDownload: 'va/export-va-accn-txn'
  },
  upiCollection: {
    upiCollectionReport: 'qr/transactions',
    upiCollectionExport: 'qr/export-qr-txn'
  },
  beneficiary: {
    beneficiaryReport: 'v2/payout/beneficiary-list',
    beneficiaryExport: 'v2/payout/beneficiary-export'
  },
  vpacreation: {
    getVpaReport: 'qr/vpa-report',
    exportVpaReport: 'qr/export-vpa-report'
  },

  kyc: {
    basicDetails: 'api/basicDetail',
    entityType: 'api/entityType',
    bankType: 'api/mbanks',
    ifscType: 'api/getIfsc',
    pennydrop: 'api/pennydrop',
    panVerify: 'api/panverify',
    aadhaarSendOtp: 'api/aadhaarSendOtp',
    aadhaarVerifyOtp: 'api/aadhaarVerifyOtp',
    upadateData: 'api/updateData',
    allKycDetails: 'api/allKycDetails',
    adminApprove: 'api/docApprove',
  },

  location: {
    stateData: 'api/getAllState',
    cityData: 'api/getAllCity',
  },

  qrCreate: {
    url: 'api/createVpa',
  },

  pincode: {
    url: 'auth/get-pincode',
  },

  notification: {
    list_url: 'auth/notifications',
    readNotification: 'auth/notification-read',
    notificationContent: 'auth/notification-content-list',
  },
  verification: {
    pan_verify: 'verification/pan-verify',
    gst_verify: 'verification/gst-verify',
    account_verify: 'verification/bank-account-verify',
    create_vpa: 'yes-bank/create-vpa',
    vpa_list: 'yes-bank/vpa-list',
    fetch_transaction: 'yes-bank/transactions',
    fetch_qr: 'yes-bank/fetch-qr',
    fetch_balance: 'yes-bank/fetch-balance'

  },
  zoho: {
    redirect_url: 'api/generate-grant-token',
    organisation_list: 'api/get-organisation-list',
    zoho_plan: 'api/plan-list',
    check_integration: 'api/check-zoho-integration',
    add_organisation: 'api/add-organisation',
    payWallet: 'api/pay-wallet',
    tally:'api/check-tally',
    other:'api/other-service'

  },

  wallet: {
    walletDetails: 'auth/wallet',
    walletUpdate: 'auth/update-wallet',
    walletStatement: 'auth/wallet-transactions',
    downloadWalletStm: 'auth/wallet-transactions-downloads',
  },
  bbps: {
    getBillerCatogryList: 'bbps/getBillerCategoryList',
    getBillerOpratorList: 'bbps/getBillerOperatorList',
    // getValidate: 'bbps/validateBillDetail',
    getValidate: 'bbps/bill-fetch',

    getInitiateBillPayment: 'bbps/initiateBillPayment'
  },
  bbpsDash: {
    getBillpayList: 'bbps/billpay-statement',
    getdownloadData: 'bbps/download-billpay-statement',
    getComplaintDesposile: 'bbps/complain-disposition-list',
    createComplaint: 'bbps/create-complain',
    checkComplaintStatus: 'bbps/check-complain-status',
    trackComplaint: 'bbps/complain-track'
  },
  invoice: {
    items: {
      list: 'api/item-list',
      add: 'api/add-item',
      edit: 'api/update-item',
      delete: 'api/delete-item',
      status: 'api/update-item-status',
      viewById: 'api/get-single-item',
      searchByItem: 'api/search-item',
      tax: 'api/tax-list',
      tallyTax:'api/tally-gst-list'
    },
    customer: {
      list: 'api/customer-list',
      create: 'api/add-customer',
      edit: 'api/update-customer',
      viewById: 'api/get-single-customer',
      searchByCustomer: 'api/search-customer'

    },
    HSN: {
      hsn_list: 'api/hsn-list'
    },
    vendor: {
      list: 'api/vendor-list',
      edit: 'api/update-vendor',
      add: 'api/add-vendor',
      search: 'api/search-vendor',
      viewVendorById: 'api/view-vendor',
      vendorAccount: 'api/get-vendor-account',
      viewPurchaseBill: 'api/get-vendor-purchase-bills'
    },
    purchaseBill: {
      list: 'api/purchase-bill-list',
      edit: 'api/update-purchase-bill',
      add: 'api/create-purchase-bill-portal',
      viewById: 'api/view-purchase',
      upload:'api/upload-file',
      zohoFile:'api/zoho-upload-bill'
    },
    payout: {
      sendOtp: 'api/send-payout-otp',
      verifyOtp: 'api/verify-payout-otp',
      payment: 'api/create-payout',
      paymentHistory: 'api/payout-list',
      getAccountList: 'api/get-account-list',
      fetchAccBalance: 'api/fetch-balance'
    },
    invoice: {
      list: 'api/invoice-list',
      createVpa: 'api/create-va-account',
      getpa: 'api/get-va-list',
      createInvoice: 'api/create-invoice',
      deleteInvoice: 'api/delete-invoice',
      QR: {
        getVpa: 'api/get-active-vpa',
        getlogo: 'api/get-qr-logo',
        vpaDetail: 'api/get-vpa-details',
        saveLogo: 'api/save-qr-logo',
        deleteLogo: 'api/delete-logo',
        createQr: 'api/create-qr',
        pincode: 'api/get-pincode',
        qrPaymentList: 'api/invoice-payment-list',
        checkBalance: 'api/check-balance',
        getVaBankList: 'api/get-bank-list'

      },
      invoicePdf: 'api/invoice-pdf-list',
      sendInvoiceEmail: 'api/send-invoice-email'
    },
    dashboard: {
      reviceInvoice: 'api/get-all-invoice',
      payBill: 'api/get-all-purchase-bill',
      totalPayable: 'api/unpaid-purchase-bill-details',
      totalRecieve: 'api/unpaid-invoice-details'

    },
    master: {
      accountList: 'api/account-list',
      unit: 'api/unit-list',
      state: 'api/state-list',
      tdsList:'api/get-tds-list',
      tallyTdsList:'api/tally-tds-list',
      tallyAccountList:'api/account-master-list'
    },
    setting: {
      deleteIntegration: 'api/delete-zoho-integration'
    },
  },
  selfTransfer:{
    selfTransfer:'v2/payout/self-payout',
    selfTransferOtp:'v2/payout/self-transfer-otp',
    getTransferStatement:'payout/self-transfer-statement',
    exportTransferStatement:'payout/export-self-transfer',
  },
  payment:{
    payment:'api/initiate-transaction',
    history:'api/payment-list',
    export:'api/payment-list-export',
    paymentStatus:'api/payment/result'
  },
  dispute: {
    disputeList:'dispute/list',
    disputeActionAdd: 'dispute/dispute-action-add',
    viewDispute:'dispute/view-dispute',
    add_comment:'dispute/dispute-chat',
    view_comments:'dispute/dispute-chat-list',
  },
  tokenauth: 'e090c25187ee2b3f9f1f8a02747356641',
  Authkey: 'MWQyMmUzNWY4YjhlNjY2NWJjM2EzZjY0NjNhZWM0ZTk=',
};
